import React, { useEffect } from "react";
import { BrowserRouter, Navigate, Route, Routes, useLocation } from "react-router-dom";
import { getSession } from "./consoleApi";
import ConsoleLayout from "./ConsoleLayout";
import ConsoleLogin from "./ConsoleLogin";
import TenantList from "./TenantList";
import TenantDetail from "./TenantDetail";
import StaffActivity from "./StaffActivity";

function RequireSession({ children }) {
  const location = useLocation();
  if (!getSession()) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  return children;
}

// The ACA staff console. Rendered instead of the tenant app on risk-console.africacodefoundry.com.
export default function ConsoleApp() {
  useEffect(() => {
    document.title = "RiskFlow Staff Console";
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<ConsoleLogin />} />
        <Route
          element={
            <RequireSession>
              <ConsoleLayout />
            </RequireSession>
          }
        >
          <Route index element={<TenantList />} />
          <Route path="tenants/:tenantId" element={<TenantDetail />} />
          <Route path="activity" element={<StaffActivity />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
